import { DEFAULT_CSS_CLASS } from '@constants';
import { getBlockClassNames } from '@components/class-dropdown';
import classnames from 'classnames';

const {
  blockEditor: { InnerBlocks, useBlockProps },
} = wp;

const Save = ({ attributes }) => {
  const {
    blockClassNames,
    childBlocksDirectionClass,
    childBlocksHorizontalAlignClass,
    displayTypeClass,
  } = attributes;

  const defaultBlockCssClass = DEFAULT_CSS_CLASS.ROW;
  const classNames = getBlockClassNames(blockClassNames);

  const blockProps = useBlockProps.save({
    className: classnames({
      [`${defaultBlockCssClass}`]: true,
      [`${displayTypeClass}`]: displayTypeClass,
      [`${childBlocksDirectionClass}`]: childBlocksDirectionClass,
      [`${childBlocksHorizontalAlignClass}`]: childBlocksHorizontalAlignClass,
      [`${classNames}`]: classNames,
    }),
  });

  return (
    <div {...blockProps}>
      <InnerBlocks.Content />
    </div>
  );
};

export default Save;
